import React, { useState, useEffect, useMemo } from "react";
import {
  Layout,
  Menu,
  Drawer,
  Button,
  MenuProps,
  Modal,
  Form,
  Input,
  Upload,
  message,
  Select,
  Avatar,
} from "antd";
import {
  MenuOutlined,
  UserOutlined,
  LogoutOutlined,
  DashboardOutlined,
  UploadOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./header-footer.css";
import useApiRequest from "../../utils/helperFunctions";
import { useForm } from "antd/es/form/Form";
import ChangePassword from "../Form/ChangePassword";

const { Header } = Layout;
const { SubMenu } = Menu;

const Navbar = (props: any) => {
  const [visible, setVisible] = useState(false);
  const [isProfile, setIsProfile] = useState(false);
  const [isEditProfile, setIsEditProfile] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [userInfo, setUserInfo]: any = useState({});
  const [form] = useForm();
  const [profileUrl, setProfileUrl] = useState("/assets/images/dummy-user.jpg");
  const [profileUploaded, setProfileUploaded] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const token = localStorage.getItem("accessToken");

  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024,
  );

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const initialMenuItems = useMemo(
    () => [
      { key: "1", title: "Home", class: "cart-icon-header", link: "/" },
      {
        key: "2",
        title: "Services",
        submenu: [
          {
            key: "VS",
            title: "Virtual Staging",
            link: "/virtual-staging",
          },
          {
            key: "VR",
            title: "Virtual Renovation",
            link: "/virtual-renovation",
          },
          {
            key: "VC",
            title: "Virtual Commercial",
            link: "/services/commercial/virtual-staging",
          },
          {
            key: "PE",
            title: "Photo Editing",
            link: "/services/photo-editing/",
          },
          {
            key: "FP",
            title: "Floor Plan",
            link: "/services/residential/floor-plan",
          },
          {
            key: "GD",
            title: "Graphic Designing",
            link: "/services/graphic-designing/",
          },
        ],
      },
      {
        key: "3",
        title: "Resources",
        submenu: [
          { key: "OG", title: "Our Gallery", link: "/gallery" },
          { key: "review", title: "Review", link: "/reviews" },
          { key: "blog", title: "Blog", link: "/blogs" },
        ],
      },
      {
        key: "4",
        title: "Contact",
        submenu: [
          { key: "CU", title: "Contact with us", link: "/contact-us" },
          { key: "BQ", title: "Bulk Quotes", link: "/order-bulk-quotes" },
          { key: "RP", title: "Refund Policy", link: "/refund-policy" },
        ],
      },
      { key: "5", title: "About", link: "/about-us" },

      {
        key: "8",
        icon: <UserOutlined />,
        title: "User",
        submenu: [
          { key: "PR", title: "Profile" },
          { key: "DS", title: "Dashboard", link: "/dashboard" },
          { key: "LG", title: "Logout" },
        ],
      },

      { key: "9", title: "Login", link: "/account" },
    ],
    [],
  );

  const [menuItems, setMenuItems] = useState([
    {
      key: "1",
      title: "Home",
      class: "cart-icon-header",
      link: "/",
    },
    {
      key: "2",
      title: "Services",
      submenu: [
        {
          key: "VS",
          title: "Virtual Staging",
          link: "/virtual-staging",
        },
        {
          key: "VR",
          title: "Virtual Renovation",
          link: "/virtual-renovation",
        },
        {
          key: "VC",
          title: "Virtual Commercial",
          link: "/services/commercial/virtual-staging",
        },
        {
          key: "PE",
          title: "Photo Editing",
          link: "/services/photo-editing/",
        },
        {
          key: "FP",
          title: "Floor Plan",
          link: "/services/residential/floor-plan",
        },
        {
          key: "GD",
          title: "Graphic Designing",
          link: "/services/graphic-designing/",
        },
      ],
    },
    {
      key: "3",
      title: "Resources",
      submenu: [
        { key: "OG", title: "Our Galllery", link: "/gallery" },
        { key: "review", title: "Review", link: "/reviews" },
        { key: "blog", title: "Blog", link: "/blogs" },
      ],
    },
    {
      key: "4",
      title: "Contact",
      submenu: [
        { key: "CU", title: "Contact with us", link: "/contact-us" },
        { key: "BQ", title: "Bulk Quotes", link: "/order-bulk-quotes" },
        { key: "RP", title: "Refund Policy", link: "/refund-policy" },
      ],
    },
    {
      key: "5",
      title: "About",
      link: "/about-us",
      // submenu: [{ key: "AU", title: "About Us", link: "/about-us" }],
    },

    {
      key: "8",
      icon: <UserOutlined />,
      title: "User",
      submenu: [
        { key: "PR", title: "Profile" },
        { key: "DS", title: "Dashboard", link: "/dashboard" },
        { key: "LG", title: "Logout" },
      ],
    },
    // {
    //   key: "7",
    //   icon: <img className="cart-logo" src="/assets/images/cart-icon.png" />,
    //   title: "Cart",
    //   class: "cart-icon-header",
    //   link:'/cart'
    // },
    {
      key: "9",
      title: "Login", //Changed to sign-up to login
      link: "/account",
    },
  ]);

  useEffect(() => {
    // Build items from the unmodified template to avoid "lost" menu entries
    const items = initialMenuItems.reduce((acc: any[], item: any) => {
      // Handle User menu (key "8")
      if (item.key === "8") {
        if (!token) {
          // If logged out, skip adding the User menu entirely
          return acc;
        }

        // If logged in, construct submenu according to viewport width
        const baseOtherUserSubs = (item.submenu || []).filter(
          (s: any) => s.key !== "PR" && s.key !== "LG",
        ); // keep DS and others but remove PR/LG (we'll add conditionally)

        const newUserSubmenu: any[] = [];

        // Add Profile only when width >= 420
        if (width >= 991) {
          newUserSubmenu.push({ key: "PR", title: "Profile" });
        }

        // Add the rest of base subs (like Dashboard)
        newUserSubmenu.push(...baseOtherUserSubs);

        // Always add Logout when logged in
        newUserSubmenu.push({ key: "LG", title: "Logout" });

        acc.push({
          ...item,
          submenu: newUserSubmenu,
        });

        return acc;
      }

      // Handle Login (key "9") — only if logged out
      if (item.key === "9") {
        if (!token) {
          acc.push(item);
        }
        return acc;
      }

      // All other items unchanged
      acc.push(item);
      return acc;
    }, []);

    setMenuItems(items);
  }, [token, width, initialMenuItems]);

  const getSelectedKeys = () => {
    for (let item of menuItems) {
      if (item.link === location.pathname) {
        return [item.key];
      }
      if (item.submenu) {
        for (let subItem of item.submenu) {
          if (subItem.link === location.pathname) {
            return [subItem.key, item.key];
          }
        }
      }
    }
    return [];
  };

  const selectedKeys = getSelectedKeys();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("LoggedIn");
    localStorage.removeItem("googleLogin");
    window.location.href = "/account";
  };

  const [scrolled, setScrolled] = useState(false);
  const { apiRequest } = useApiRequest();
  const locationPath = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        // Adjust this value as needed
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    // console.log("click", e);
  };

  const handleProfile = async () => {
    try {
      const resp = await apiRequest({
        url: "profile",
        method: "GET",
        showMessage: false,
        payload: {},
      });
      // console.log(resp);

      if (resp.status === 200) {
        // console.log(localStorage.getItem("accessToken"));
        // console.log("===>>>>", resp?.data?.user_avatar);
        setUserInfo(resp.data);
        setProfileUrl(resp?.data?.user_avatar.replace(/\?.*$/, ""));
        form.setFieldsValue(resp.data);
        // userDetailsFetched = true;
      }
    } catch (errors) {
      console.error("Failed to fetch service list", errors);
    }
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");

    if (accessToken && refreshToken) {
      handleProfile();
    } else if (isProfile) {
      handleProfile();
    }
  }, [isProfile, token]);

  const onFinish = async () => {
    try {
      let payload = form.getFieldsValue();

      if (profileUploaded) {
        payload.user_avatar = profileUrl.toString();
      }

      const resp = await apiRequest({
        url: "/profile-update",
        method: "PUT",
        showMessage: false,
        payload: payload,
      });
      // console.log(resp);
      if (resp.status === 200) {
        message.success("Profile updated successfully");
        setIsProfile(false);
      }
    } catch (errors) {
      message.error("Failed to update profile.");
      console.error("Failed to update profile", errors);
    }
  };

  const items: MenuProps["items"] = [
    {
      label: "Profile",
      key: "1",
      icon: <UserOutlined />,
      // onClick: () => navigate('/profile'),
      onClick: () => setIsProfile(true),
    },
    {
      label: "Dashboard",
      key: "2",
      icon: <DashboardOutlined />,
      onClick: () => navigate("/dashboard"),
      // onClick: () => setIsProfile(true),
    },
    {
      label: "Logout",
      key: "3",
      onClick: () => handleLogout(),
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const handleUploadMedia = (file: any) => {
    const formData = new FormData();
    formData.append("file", file);

    return fetch(`${process.env.REACT_APP_API_URL}/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`, // Adjust the token retrieval as needed
      },
      body: formData,
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  };

  // console.log("handleUploadMedia", handleUploadMedia);

  const handleUploadChange = ({ fileList }: any) => {
    // console.log("Uploading", fileList);

    if (fileList[0]?.status === "done") {
      setProfileUrl(fileList[0]?.response?.file_url);
      setProfileUploaded(true);
    } else if (fileList[0]?.status === "error") {
      message.error(`${fileList[0]?.name} file upload failed.`);
    }
  };
  return (
    <>
      <Header
        className={`main-header ${
          props?.bgWhite === true ? "header_scrolled" : ""
        } ${scrolled ? "header_scrolled" : ""} ${
          props?.static == true
            ? "static-header"
            : props?.static != false
            ? true
            : false
        } ${location.pathname.includes("/blogs") ? "header_scrolled" : ""}`}
      >
        <div className="logo">
          <Link to="/" className="logoTransparent">
            <img src="/assets/images/WHITE_BOTH.svg" alt="Stagobox" />
          </Link>
          <Link to="/" className="logoWhite">
            <img src="/assets/images/fullLogoBlack.svg" alt="Stagobox" />
          </Link>
        </div>
        <Menu
          theme="light"
          mode="horizontal"
          selectedKeys={selectedKeys}
          className="main-navbar"
          style={{
            flex: 1,
            minWidth: 0,
            justifyContent: "right",
            border: 0,
            alignItems: "center",
          }}
        >
          {menuItems?.map((item) =>
            item.submenu ? (
              item.key != "8" ? (
                <SubMenu
                  className="header-child-menu"
                  key={item.key}
                  title={
                    <>
                      {item.title + " "}
                      <DownOutlined style={{ fontSize: "12px" }} />
                    </>
                  }
                >
                  {item.submenu.map((subItem) => (
                    <Menu.Item key={subItem.key}>
                      {subItem?.link ? (
                        <Link to={subItem.link}>{subItem.title}</Link>
                      ) : (
                        <div
                          key={subItem.key}
                          onClick={() => {
                            localStorage.removeItem("accessToken");
                            localStorage.removeItem("refreshToken");
                            localStorage.removeItem("LoggedIn");
                            window.location.href = "/";
                          }}
                        >
                          {subItem.title}
                        </div>
                      )}
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : token ? (
                <SubMenu
                  className="header-child-menu signed-user-name"
                  key={item.key}
                  title={
                    userInfo.first_name
                      ? userInfo.first_name
                      : userInfo.username
                      ? userInfo.username
                      : "User"
                  }
                >
                  {item.submenu.map((subItem) => (
                    <Menu.Item key={subItem.key}>
                      {subItem?.link ? (
                        <Link to={subItem.link}>{subItem.title}</Link>
                      ) : subItem.key == "PR" ? (
                        <div
                          key={subItem.key}
                          onClick={() => setIsProfile(true)}
                        >
                          {subItem.title}
                        </div>
                      ) : (
                        <div
                          key={subItem.key}
                          onClick={() => {
                            localStorage.removeItem("accessToken");
                            localStorage.removeItem("refreshToken");
                            localStorage.removeItem("LoggedIn");
                            window.location.href = "/";
                          }}
                        >
                          {subItem.title}
                        </div>
                      )}
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : null
            ) : item.key != "9" ? (
              <Menu.Item key={item.key}>
                <Link to={item.link}>{item.icon}</Link>
                <span className={item.class}>
                  <Link to={item.link}>{item.title}</Link>
                </span>
              </Menu.Item>
            ) : !token ? (
              <Menu.Item key={item.key}>
                <Link to={item.link}>{item.icon}</Link>
                <span className={item.class}>
                  <Link to={item.link}>{item.title}</Link>
                </span>
              </Menu.Item>
            ) : null,
          )}
        </Menu>

        {/* {token ? (
          // <Button
          //   onClick={() => handleLogout()}
          //   className="theme-btn"
          //   style={{ lineHeight: 0 }}
          // >
          //   Logout
          // </Button>
          <Space wrap>
            <Dropdown menu={menuProps} placement="bottom">
              <Button
                style={{ background: "transparent", border: 0, padding: 0 }}
              >
                <UserOutlined />
              </Button>
            </Dropdown>
          </Space>
        ) : (
          <Link to="/cart" title="cart">
            <img className="cart-logo" src="/assets/images/cart-icon.png" />
          </Link>
          // <Link style={{ color: "var(--primary)" }} to="/account">
          //   Sign in
          // </Link>
        )} */}
        {token ? (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <Link
              to={token ? "/cart" : "/account"}
              title={token ? "Cart" : "Login first"}
            >
              <img className="cart-logo" src="/assets/images/cart-icon.png" />
            </Link>

            <div
              style={{ cursor: "pointer" }}
              onClick={() => setIsProfile(!isProfile)}
              className="header-user-avatar cart-logo"
            >
              <Avatar
                style={{ background: "transparent" }}
                icon={<UserOutlined style={{ color: "white" }} />}
              />
            </div>
          </div>
        ) : null}

        <MenuOutlined className="menu-icon" onClick={showDrawer} />
      </Header>

      <Drawer
        title="Menu"
        placement="left"
        onClose={onClose}
        open={visible}
        width="75%"
        className="main-drawer"
      >
        <Menu selectedKeys={selectedKeys} mode="inline">
          {menuItems.map((item) =>
            item.submenu ? (
              <SubMenu key={item.key} title={item.title}>
                {item.submenu.map((subItem) => (
                  <Menu.Item key={subItem.key}>
                    {subItem?.link ? (
                      <div
                        onClick={() => {
                          navigate(subItem.link);
                        }}
                      >
                        {subItem.title}
                      </div>
                    ) : (
                      // <Link to={subItem.link}>{subItem.title}</Link>
                      <div
                        key={subItem.key}
                        onClick={() => {
                          localStorage.removeItem("accessToken");
                          localStorage.removeItem("refreshToken");
                          localStorage.removeItem("LoggedIn");
                          window.location.href = "/";
                        }}
                      >
                        {subItem.title}
                      </div>
                    )}
                  </Menu.Item>
                ))}
              </SubMenu>
            ) : (
              <Menu.Item key={item.key}>
                <Link onClick={onClose} to={item.link}>
                  {item.title}
                </Link>
              </Menu.Item>
            ),
          )}
        </Menu>
      </Drawer>

      <Modal
        title="Profile Information"
        open={isProfile}
        footer={false}
        onCancel={() => setIsProfile(false)}
        destroyOnClose
      >
        <div className="profile-info-box">
          {/* <EditOutlined
            onClick={() => setIsEditProfile(!isEditProfile)}
            style={{
              color: "var(--primary)",
              fontSize: "26px",
              position: "absolute",
              top: "50px",
              right: "30px",
            }}
          /> */}
          <div className="profile-img mt-4 mb-4">
            <img
              src={
                profileUrl
                  ? profileUrl?.toString()
                  : "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 512 512'%3E%3ClinearGradient id='a' x1='-13.895' x2='511.418' y1='13.895' y2='511.418' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23a4ff00'/%3E%3Cstop offset='1' stop-color='%23002fff'/%3E%3C/linearGradient%3E%3Ccircle cx='256' cy='256' r='256' fill='url(%23a)'/%3E%3Cpath fill='%23fff' d='M256 304.5c-80.4 0-146 30.4-146 74.4v30.4c0 5.8 4.6 10.5 10.3 10.5h271.5c5.7 0 10.3-4.7 10.3-10.5v-30.4c0-44-65.6-74.4-146.1-74.4zM256 283.3c55.8 0 101.4-46 101.4-102.7 0-56.8-45.6-102.8-101.4-102.8S154.6 123.8 154.6 180.6c0 56.7 45.6 102.7 101.4 102.7z'/%3E%3C/svg%3E"
              }
              alt="User Profile"
            />
          </div>
          <div className="profile-details">
            <div className="text-right">
              <Upload
                onChange={handleUploadChange}
                customRequest={({ file, onSuccess, onError }) => {
                  handleUploadMedia(file).then(onSuccess).catch(onError);
                }}
                showUploadList={false}
                maxCount={1}
              >
                <Button
                  // disabled={!isEditProfile}
                  icon={<UploadOutlined />}
                >
                  Update profile picture
                </Button>
              </Upload>
            </div>
            {/* <h2>User Details</h2> */}
            <Form
              layout="vertical"
              form={form}
              initialValues={userInfo}
              onFinish={onFinish}
              // onFinishFailed={onFinishFailed}
            >
              <Form.Item
                label="Username"
                name="username"
                rules={[
                  { required: true, message: "Please enter your username." },
                  {
                    pattern: /^[a-zA-Z0-9@.+\-_]+$/,
                    message:
                      "Invalid username. Can contain only letters, numbers, and @/./+/-/_ characters.",
                  },
                ]}
              >
                <Input
                  placeholder="Enter your name"
                  // disabled={!isEditProfile}
                />
              </Form.Item>
              <Form.Item
                label="Name"
                name="first_name"
                rules={[
                  { required: true, message: "Please enter your name." },
                  {
                    pattern: /^[a-zA-Z\s]+$/,
                    message: "Please use letter and spaces only.",
                  },
                ]}
              >
                <Input
                  placeholder="Enter your name"
                  // disabled={!isEditProfile}
                />
              </Form.Item>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please input your Email!" },
                  {
                    type: "email",
                    message: "The input is not a valid E-mail!",
                  },
                ]}
              >
                <Input placeholder="Enter your email" disabled />
              </Form.Item>
              <Form.Item
                label="Phone"
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "Please enter your Phone number.",
                  },
                  {
                    pattern: /^\d{10}$/,
                    message: "Phone number must be exactly 10 digits",
                  },
                ]}
              >
                <Input
                  placeholder="Enter your phone number"
                  // disabled={!isEditProfile}
                />
              </Form.Item>
              {/* <Form.Item label="Address" name="address">
                <Input
                  placeholder="Enter your address"
                  disabled={!isEditProfile}
                />
              </Form.Item> */}
              {/* <Form.Item label="Password">
                  <Input.Password placeholder="Enter your password" />
                </Form.Item> */}
              {/* <Form.Item label="Confirm Password">
                  <Input.Password placeholder="Confirm your password" />
                </Form.Item> */}
              <Form.Item
                name="company"
                label="Industry"
                className="field"
                rules={[
                  {
                    required: true,
                    message: "Select your Industry!",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select an Industry"
                  // disabled={!isEditProfile}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value: "Real Estate Agent / Broker",
                      label: "Real Estate Agent / Broker",
                    },
                    {
                      value: "Developer / Builder / Construction",
                      label: "Developer / Builder / Construction",
                    },
                    {
                      value: "Property Management",
                      label: "Property Management",
                    },
                    {
                      value: "Short Stay Accomondation",
                      label: "Short Stay Accomondation",
                    },
                    { value: "Photographer", label: "Photographer" },
                    { value: "Ecommerce", label: "Ecommerce" },
                    { value: "Other", label: "Other" },
                  ]}
                />
              </Form.Item>
              {localStorage?.getItem("googleLogin") == "true" ? null : (
                <p
                  onClick={() => {
                    setChangePassword(true);
                    setIsProfile(false);
                  }}
                  style={{
                    textAlign: "right",
                    textDecoration: "underline",
                    margin: "0",
                    cursor: "pointer",
                    color: "var(--primary)",
                  }}
                >
                  Change Password ?
                </p>
              )}

              <Form.Item>
                <button type="submit" className="theme-btn w-100 mt-4">
                  Update Profile
                </button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Modal>
      {/* <Link style={{position:"fixed", top:"200px", zIndex:"99999999"}} to="/test">Click here to go testpage</Link> */}
      {/* ================= Change Password ================= */}
      <Modal
        open={changePassword}
        destroyOnClose
        onCancel={() => setChangePassword(false)}
        title="Change Password"
        footer={null}
      >
        <ChangePassword />
      </Modal>
    </>
  );
};

export default Navbar;
